<template>
  <div class="orderContent">
    <navBar :title="topTitle"></navBar>
    <!--代配送订单流程-->
    <div class="box" style="position:relative;">
      <van-steps direction="vertical" active="10" active-color="#8D95A6">
        <van-step v-for="(sItem,sIndex) in orderInfo.order_log" :key="sIndex">
          <div class="flexBetween">
            <b class="title">{{sItem.content}}</b>
            <p class="time">{{sItem.opeate_time}}</p>
          </div>
        </van-step>
      </van-steps>
      <div class="failInfo" v-if="statusId==1" style="position:absolute;top: 30px;left: 50px;color: #DE1919;font-weight: bold;font-size: 12px;">失败原因：{{orderInfo.comment}}</div>
    </div>

    <!--电话联系-->
    <div class="orderInfo box" v-if="orderInfo.order_address" style="display: flex;justify-content: center;align-items: center;height: 40px;background: #F5f5f5;font-size: 12px;color: #8D95A6s;" @click="contactUser">
      <div class="phone"></div>联系商家
<!--      <div class="telBox flexBetween">-->
<!--        <div class="left">-->
<!--          <div class="address">{{orderInfo.order_address.address}}-->
<!--          </div>-->
<!--          <div class="info">{{orderInfo.order_address.contacts + ' ' +-->
<!--            orderInfo.order_address.mobile}}-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="phone" @click="contactUser"></div>-->
<!--      </div>-->
    </div>

    <!--订单信息-->
    <div class="shops box">
      <div class="topTitle flexBetween">
        <div class="name">{{orderInfo.shop_name}}</div>
        <div class="status" v-if="orderInfo.order_status==26">配单中</div>
        <div class="status" v-if="orderInfo.order_status==27">待取货</div>
        <div class="status blue" v-if="orderInfo.order_status==31">代配送</div>
        <div class="status" v-if="orderInfo.order_status==40">已完成</div>
      </div>

      <!--      <van-checkbox-group v-model="checkList[cIndex]">-->
      <div class="item flexBetween" v-for="(lItem,lIndex) in orderInfo.goods_list" :key="lIndex">
        <div class="imgBox">
          <img :src="lItem.sku_master_img" alt="">
        </div>
        <div class="itemInfo">
          <div class="name">{{lItem.sku_title}}</div>
          <div class="priceBox flexBetween">
            <div class="price">￥{{lItem.price}}</div>
            <div class="num">×{{lItem.qty}}</div>
          </div>
        </div>
        <!--        <van-checkbox slot="right-icon" :name="lItem.id" ref="checkboxes" v-if="status==27" />-->
      </div>
      <!--      </van-checkbox-group>-->

      <div class="compute flexBetween">
        <div class="btnBox">
          <!--          <van-button round color="#687BFF">确认收货</van-button>-->
        </div>
        <div class="total">小计：<span>￥{{orderInfo.goods_amount}}</span></div>
      </div>
    </div>

    <div class="orderInfo box">
      <div class="title">订单信息</div>
      <div class="infoCont">
        <div class="orderSn flexBetween">
          <div class="name">订单号</div>
          <div class="value">{{orderInfo.order_sn}}
            <span v-clipboard:copy="orderInfo.order_sn" v-clipboard:success="copySuc"
                  v-clipboard:error="copyFail">复制</span></div>
        </div>
        <div class="orderTime flexBetween">
          <div class="name">下单时间</div>
          <div class="value">{{orderInfo.create_time}}</div>
        </div>
      </div>

    </div>


    <van-button type="primary" block @click="sureOrder"
                :loading="loading"
                loading-type="circular"
                :loading-text="buttonText" v-if="statusId==27||statusId==31">{{buttonText}}
    </van-button>

    <div class="btnGroup" v-if="statusId==20">
      <van-button color="#687BFF" block @click="sureOrder"
                  :loading="loading"
                  :disabled="isDisable"
                  loading-type="circular"
                  :loading-text="buttonText">{{buttonText}}
      </van-button>
      <van-button color="#DE1919" plain block @click="pickerShow = true">取件失败</van-button>
    </div>

    <!--取件失败原因-->
    <van-overlay :show="pickerShow">
      <van-picker
              show-toolbar
              title="取件失败原因"
              :columns="columns"
              @cancel="pickerShow = false"
              visible-item-count="3"
              @confirm="pickerConfirm"
      />
    </van-overlay>
  </div>
</template>

<script>
  import navBar from "../../../components/navBar";
  import Vue from 'vue';
  import {Toast, Button, Loading, Step, Steps,Dialog,ImagePreview,Picker,Overlay} from 'vant';

  Vue.use(Toast).use(Button).use(Loading).use(Step).use(Steps).use(Dialog).use(ImagePreview).use(Picker).use(Overlay);
  export default {
    name: "orderContent",
    components: {
      navBar
    },
    data() {
      return {
        isDisable:false,
        pickerShow:false,//选择器显示
        columns:['取件码错误','收件人错误','收件人手机号错误'],//取件失败原因
        topTitle: '',
        loading: false,//按钮加载
        orderInfo: {},
        orderId: this.$route.query.id,
        statusId: this.$route.query.status,
        buttonText: ''
      }
    },
    mounted() {
      this.getTopTitle();
      this.getOrderInfo();
    },
    methods: {
      pickerConfirm(value){
        this.pickerShow = false;
        this.sendHttp({
          method: 'post',
          url: `${this.orderUrl}/marketexpressreceipt/fail`,
          data: {
            market_express_id: this.orderId,
            fail_msg:value
          }
        }).then(res=>{
          if(res.code=='0'){
            this.$router.push('/qjOrder');
          }
          Toast(res.msg)
        })
      },

      //图片打开
      showImg(){
        if(this.orderInfo.images){
          ImagePreview({
            images: this.orderInfo.images,
            startPosition: 1,
            onClose() {
              // do something
            }
          });
        }

      },
      //拨打电话
      contactUser(){
        Dialog.confirm({
          message: this.orderInfo.order_address.mobile,
          confirmButtonText:'呼叫'
        }).then(() => {
          window.location.href = `tel:${this.orderInfo.order_address.mobile}`;
        }).catch(() => {
          // on cancel
        });

      },
      //订单提交
      sureOrder() {
        this.isDisable = true;
        let statusId = this.statusId;
        //待确认送达
        if (this.orderId && statusId == '31') {
          this.loading = true;
          this.sendHttp({
            method: 'post',
            url: `${this.orderUrl}/communityorder/complete`,
            data: {
              id: this.orderId
            }
          }).then(res => {
            this.loading = false;
            this.isDisable = false;
            if (res.code == '0') {
              this.$router.push('/childOrder');
            }
            Toast(res.msg);
          })
        }

      },
      //获取头部标题
      getTopTitle() {
        let statusId = this.$route.query.status;
        if (statusId == 26) {
          this.topTitle = '订单-配单中';
        }
        if (statusId == 27) {
          this.topTitle = '订单-待取货';
          this.buttonText = '确认取货';
        }
        if (statusId == 31) {
          this.topTitle = '订单-待配送';
          this.buttonText = '确认送达';
        }
        if (statusId == 40) {
          this.topTitle = '订单-已完成';
        }
      },
      //获取当前订单详情
      getOrderInfo() {
        if (this.orderId) {
          this.sendHttp({
            method: 'post',
            url: `${this.orderUrl}/order/detail`,
            data: {
              order_id: this.orderId
            }
          }).then(res => {
            console.log(res)
            this.orderInfo = res.data;
          })
        }
      },
      copySuc() {
        Toast('复制成功');
      },
      copyFail() {
        Toast('复制失败');
      }
    }
  }
</script>

<style scoped lang="less">
  .shops {
    .topTitle {
      height: 44px;
      background: #fff;
      border-bottom: 1px solid #F5f5f5;

      .name {
        font-size: 12px;
        color: #666;
        padding-left: 24px;
        letter-spacing: 1px;
        background: url('../../../assets/images/ddpartner/shopsIcon.png') no-repeat left center;
        background-size: contain;
      }
      .blue{
        color: #687BFF;
      }
    }

    .item {
      position: relative;
      border-bottom: 1px solid #F5f5f5;
      padding: 9px 0;
      .van-checkbox{
        position: absolute;
        top: 32px;
        right: 20px;
      }
      .imgBox {
        background: #eee;
        width: 60px;
        height: 60px;
        overflow: hidden;

        img {
          width: 100%;
        }
      }

      .itemInfo {
        width: 270px;

        .priceBox {
          margin-top: 18px;

          .price {
            font-size: 16px;
            color: #DE1919;
          }
        }
      }
    }

    .compute {
      height: 44px;
    }
  }
  .van-overlay{
    display: flex;
    align-items: flex-end;
    z-index:100;
  }
  .van-picker{
    width: 100%;
  }
  .btnGroup{
    margin: 20px 0;
    .van-button--block{
      width: 347px;
      margin: 20px auto;
      border: none;
      font-size: 16px;
    }
  }
  .expressImg{
    height: 88px;
    .imgBox{
      width: 70px;
      height: 70px;
      overflow: hidden;
      margin: 10px 0;
      margin-right: 16px;
      img{
        width: 100%;
      }
    }
  }
  .expressContent{
    padding: 6px 0;
    line-height: 24px;
  }
  .van-button--primary {
    background-color: #687BFF;
    border: none;
    font-size: 16px;
    width: 347px;
    margin: 30px auto;
    height: 48px;
    line-height: 48px;
  }

  .orderContent {
    background: #f5f5f5;
    position: absolute;
    width: 100%;
    min-height: 100%;

    .box {
      background: #fff;
      margin-top: 6px;
      padding: 0 14px;

      .left {
        padding: 12px 0;

        .info {
          color: #8D95A6;
          font-size: 13px;
          line-height: 30px;
        }
      }

      .phone {
        width: 17px;
        height: 17px;
        background: url("../../../assets/images/phone.png") no-repeat;
        background-size: contain;
        margin-right: 10px;
      }
    }

    .orderInfo {
      .title {
        line-height: 44px;
        border-bottom: 1px solid #F5f5f5;
        font-weight: bold;
      }

      .infoCont {
        line-height: 26px;
        padding: 10px 0;

        .name {
          color: #8D95A6;
        }

        .value {
          span {
            padding-left: 10px;
            color: #687BFF;
            text-decoration: underline;
          }
        }
      }

    }

    .orderitem {
      line-height: 40px;
      font-size: 14px;

      .bPrice {
        color: #687BFF;
      }

      .rPrice {
        color: #DE1919;
      }
    }
  }

</style>
<style>
  .van-picker-column__item{
    color: #687BFF;
  }
  .van-picker__title{
    font-size: 18px;
  }
  .van-step--finish .van-step__circle, .van-step--finish .van-step__line {
    background: #8D95A6 !important;
  }
</style>
